
export class DownloadRequestInfo{
    isInitiated: boolean;
    isFinalised: boolean;
}